import React from 'react';
import { StyleSheet, View, Text, TouchableHighlight } from './base_components';

const styles = StyleSheet.create({
  selectBar: {
    height: '3rem',
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#677078',
    borderRadius: '0.3rem',
  },
  item: {
    margin: -1,
    width: '6rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
    borderWidth: 1,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    borderLeftColor: 'transparent',
    borderRightColor: '#677078',
  },
  first: { borderTopLeftRadius: '0.3rem', borderBottomLeftRadius: '0.3rem' },
  last: {
    borderRightColor: 'transparent',
    borderTopRightRadius: '0.3rem',
    borderBottomRightRadius: '0.3rem',
  },
  selectedItem: {
    backgroundColor: '#0273ba',
    borderColor: 'black',
    pointerEvents: 'none',
    userSelect: 'none',
  },
  highlight: { flex: 1, alignSelf: 'stretch', flexDirection: 'column' },
  tabInner: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: { color: '#545b64', fontSize: '1.4rem', fontWeight: '600' },
  selectedText: { color: 'white' },
});
type Props = {
  style?: any;
  value?: any;
  options: any[];
  onChange?: (value: any) => void;
};
export default function SelectBar(props: Props) {
  const { style, value, options, onChange } = props;
  return (
    <View style={[styles.selectBar, style]}>
      {options.map((item, i) => {
        return (
          <Item
            key={i}
            text={item.text}
            value={item.value}
            first={i === 0}
            last={i === options.length - 1}
            selected={item.value === value}
            onPress={onChange}
          />
        );
      })}
    </View>
  );
}
function Item(props: any) {
  const { text, first, last, selected } = props;

  function _onPress() {
    props.onPress(props.value);
  }
  let content = (
    <View style={styles.tabInner}>
      <Text style={[styles.text, selected ? styles.selectedText : null]}>
        {text}
      </Text>
    </View>
  );

  if (!selected) {
    content = (
      <TouchableHighlight
        style={styles.highlight}
        underlayColor='rgba(0,0,0,0.1)'
        onPress={_onPress}
      >
        {content}
      </TouchableHighlight>
    );
  }

  return (
    <View
      style={[
        styles.item,
        first ? styles.first : null,
        last ? styles.last : null,
        selected ? styles.selectedItem : null,
      ]}
    >
      {content}
    </View>
  );
}
